// extracted by mini-css-extract-plugin
export default {"banner_wrapper":"homepageBanner_banner_wrapper__uKlOS"};